import { Component, inject, OnInit, TemplateRef } from '@angular/core';
import {
  Router,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
} from '@angular/router';
import { LoadingService } from 'src/app/services/loading/loading.service';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
})
export class BaseComponent implements OnInit {
  isLoading: boolean;
  navbarLoading: boolean = true;

  loader = true; // Loader for the whole application

  constructor(private router: Router, private loadingService: LoadingService) {
    // Spinner for whole application
    this.loadingService.isLoading.subscribe((res: boolean) => {
      this.loader = res;
    });

    // Spinner for lazyload modules
    router.events.forEach((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        if (this.navbarLoading) this.isLoading = true;
        else this.isLoading = false;
      }
    });
  }

  navbarLoader(e: boolean) {
    this.navbarLoading = e;
  }

  ngOnInit(): void {}
}
